/**
 * Handles the plp lazy loading and back button functionality
 * Lazy loads the images once window loads.
 * Fixes the correct page position if going back to plp.
 * @module sizeSelection
 */

import $ from 'jquery';
import registerJQueryPlugin from 'styleguide/lib/register-jquery-plugin';
import mergeOptions from 'styleguide/lib/merge-options'

export const PLUGIN_NAME = 'sizeSelection';
export const SS_TRIGGER_CLASS = '.js-select-size-trigger';
export const DEFAULTS = {
    sessionName: '',
    loadAfterCallback: function () { }
};


const showConfirmation = (opts, hasError) => {
    const {saveSizeConfirmPath} = opts;
    $.modal({
        url: `${saveSizeConfirmPath}${hasError}`,
        triggerOpen: true,
        type: 'notification',
    })
}

const updateSizeToDb = ($el, opts, sizeValue) => {
    if (sizeValue) {
        const {updateSizePath, code} = opts;
        $.ajax({
            url: `${updateSizePath}${sizeValue}`,
            type: "POST",
            success: function (ret) {
                if (ret.success) {
                    const $preorderCta = $(`#preorder-cta-${code}`);
                    const $addToBagCta = $(`#add-to-bag-cta-${code}`);
                    const $addToBagBtn = $(`#add-to-bag-${code}`);
                    const $outOfStockBtn = $(`#outOfStock_${code}`);
                    if ($outOfStockBtn.length) {
                        $addToBagBtn.show();
                        $outOfStockBtn.remove();
                    }
                    if (ret.isPreorder) {
                        $preorderCta.show();
                        $addToBagCta.hide();
                    } else {
                        $preorderCta.hide();
                        $addToBagCta.show();
                    }
                    showConfirmation(opts, false);
                    if(typeof logEngagementWithDetails === "function") {
                        logEngagementWithDetails(window.location.href, 'favorites save your size', 'SaveSize', `size=${sizeValue}, code=${code}`);
                    }
                }
            }
        });
    } else {
        showConfirmation(opts, true);
    }
}

const setUpdateSizeListener = ($el, $saveSizeTrigger, opts) => {
    $('input[name="fav-size-selection"]').on('change', function() {
        const sizeSelected = $(this).val();
        const isOneLeft = $(this).data('isOneLeft');
        const {code, addToBag, updateSizePath, hideCopy} = opts;
        const hideClass = opts.hideCopy ? "class=\"u-hide\"" : "";
        $saveSizeTrigger.html(`<span id="${code}-fav-size-value" data-size="${sizeSelected}" ${hideClass}>Size: ${sizeSelected}</span>`); // update size copy
        const $soldOut = $el.find('.js-saved-size-sold-out');
        const $oneLeft = $el.find('.js-saved-size-one-left');
        if ($soldOut.length) {
            $soldOut.hide();
        }
        if (isOneLeft !== undefined && $oneLeft.length) {
            if (isOneLeft) {
                $oneLeft.show();
            } else {
                $oneLeft.hide();
            }
        }
        if (updateSizePath) {
            updateSizeToDb($el, opts, sizeSelected);
        }
        if (addToBag === 'true' || addToBag === true) {
            const $addToBag = $(`#add-to-bag-${code}`);
            if ($addToBag.length) {
                $addToBag.data('size', sizeSelected);
                $addToBag.click();
            }
        }
    })
}


const getSizes = ($el, $saveSizeTrigger, opts) => {
    opts.addToBag = $el.data('addToBag');
    const sizePath = window.rcProps.sizeMarkupUri + '?code=' + $el.data('code');

    $el.data('addToBag', 'false');
    $.modal({
        url: sizePath,
        triggerOpen: true,
        type: "toast",
        addModifierClass: 'modal--toast-sizes',
        overlayClose: false,
        returnFocus: $el.find('.js-select-size-trigger'),
        onComplete: function() {
            setUpdateSizeListener($el, $saveSizeTrigger, opts);
            if (typeof window.bindSizeGuideEvent() === 'function') {
                window.bindSizeGuideEvent()
            }
        }
    })

    if (typeof window.showBisOrSo !== "function") {
        window.showBisOrSo = (code) => {
            $.modal({
                url: window.rcProps.backInStockSpecialOrderHref + "&code=" + code,
                type: "full",
                open: null,
                cache: false,
                overlayClose: true,
                triggerOpen: true,
                returnFocus: $el.find('.js-select-size-trigger'),
                onComplete: function () {
                    $(".js-tabs").tabs();
                    setupBisAndSo();
                }
            });
        }
    }
}

/**
 * Applies any sort of event handlers for the switchClass.
 * @param  {jQuery} $el - link
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
const setEventListeners = ($el, $saveSizeTrigger, opts) => {
    $saveSizeTrigger.on('click', (evt) => {
        evt.preventDefault();
        getSizes($el, $saveSizeTrigger, opts);
    });
};


/**
 * Initializes sizeSelection.
 * @param {jQuery} el - targeting the element of the plp list
 * @param {Object} options - Options used for wiring up the sizeSelection
 * @see DEFAULTS
 */
export default function sizeSelection(el, options = {}) {
    const $el = $(el);
    const opts = mergeOptions(DEFAULTS, options, $el);
    const $saveSizeTrigger = $el.find(SS_TRIGGER_CLASS);
    setEventListeners($el, $saveSizeTrigger, opts);
}

registerJQueryPlugin(PLUGIN_NAME, sizeSelection);



// WEBPACK FOOTER //
// ./src/scripts/entry-points/plp/size-selection.js